export default __webpack_public_path__ + "static/media/maintenance.571bae3e.svg";